import { useEffect, useState } from "react";
import {
  ChallengeCardSummaryType,
  ChallengeCardType,
  ChallengeFormType,
  getAllChallenges,
} from "./challengeAPI";
import { FundsCardType, getAllFunds } from "./fundsAPI";
import {
  getAllProposals,
  ProposalCardSummaryType,
  ProposalFormType,
} from "./proposalAPI";
import {
  SingleProposalFormType,
  SingleProposalType,
  getSingleProposal,
} from "./proposalAPI";
import {
  getAllProposers,
  proposerCardSummaryType,
  proposerFormType,
} from "./proposerAPI";
import {
  getSingleProposer,
  SingleProposerFormType,
  SingleProposerInfoType,
} from "./proposerAPI";
import { FundCardType, getSingleFund, SingleFundFormType } from "./fundsAPI";
import { getSingleChallenge, singleChallengeFormType } from "./challengeAPI";
import {
  ChallengeAnalyticsData,
  FundsBudgetAnalytics,
  getChallengeBugetPerFunds,
  getFundsBudgetAnalytics,
  getCompletedCounts,
  getProposalRankings,
  getProposerRankings,
  completedCountFormDataType,
  filterProposalFormType,
  FundAvailibilityType,
  getFundAvailibilityPerChallenge,
  PropertyAPIType,
  getProperty,
  getProjectStatus,
  ProjectStatusFromType,
  PropertiesFormType,
  getProperties,
  getCompletionTimeROI,
  ProposerCorrelationFormType,
  getProposerCorrelationMatrix,
  HomePageQuickStats,
  PowerIndexAPIInputTypes,
  getPowerIndex,
} from "./analyticsAPI";
import {
  challengeNamesDataType,
  getAllChallengeNames,
  getAllFundNames,
  getChallengeNames,
} from "./generalInfoAPI";
import {
  GetSentimentsAPIReqTypes,
  TweetsTypes,
  getTwitterDistribution,
  GetTwitterDistributionTypes,
  getTwitterProperty,
  GetTwitterPropertyTypes,
  getTwitterSentiments,
  getTwitterWordCloud,
  GetTwitterWordCloudTypes,
  SentimentsResultsTypes,
  getTweetsOptions,
  getTweets,
  GetForumWordCloudTypes,
  getForumWordCloud,
  GetForumPostTypes,
  getForumPosts,
  GetRedditWordCloudTypes,
  getRedditWordCloud,
  GetRedditDistributionTypes,
  getRedditDistribution,
  GetRedditSentimentsAPIReqTypes,
  getRedditSentiments,
  GetRedditPropertyTypes,
  getRedditProperty,
  GetRedditAPIPropsType,
  getReddits,
} from "./twitterAPI";

export const useAllFundsData = () => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<FundsCardType[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getAllFunds();

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, []);

  return { loading: pending, fundsData: data, error };
};

export const useQuickStatsData = () => {
  const initialData = {
    total_proposals: 0,
    fund_budget: 0,
    amount_requested: 0,
    funded_proposals: 0,
    funded_amount: 0,
    no_of_funds: 0,
    regular_challenges: 0,
  };

  const [pending, setPending] = useState(true);
  const [data, setData] = useState<HomePageQuickStats>(initialData);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getAllFunds();

      if (error === null) {
        setErrors(null);
        setData(response);
        let data: HomePageQuickStats = {
          total_proposals: 0,
          fund_budget: 0,
          amount_requested: 0,
          funded_proposals: 0,
          funded_amount: 0,
          no_of_funds: 0,
          regular_challenges: 0,
        };
        response.forEach((item: FundsCardType) => {
          Object.keys(item.quick_stats_data).forEach((keys: any) => {
            data[keys as keyof HomePageQuickStats] +=
              item.quick_stats_data[keys as "total_proposals"];
          });
        });
        data.no_of_funds = response.length;
        setData(data);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData(initialData);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, []);

  return { loading: pending, statsData: data, error };
};

export const useAllChallengeData = (formData: ChallengeFormType) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<ChallengeCardSummaryType>({
    number_of_rows: 0,
    items: [],
  });
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getAllChallenges(formData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Challenge Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData({ number_of_rows: 0, items: [] });
      }
      setPending(false);
    })();
  }, [formData]);

  return { loading: pending, challengesData: data, error };
};

export const useAllProposalsData = (formData: ProposalFormType) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<ProposalCardSummaryType>({
    number_of_rows: 0,
    items: [],
  });
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getAllProposals(formData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Proposals Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }
        setData({ number_of_rows: 0, items: [] });
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [
    formData.amount_requested,
    formData.challenge_id,
    formData.fund_id,
    formData.funded_status,
    formData.is_challenge_proposal,
    formData.num_per_page,
    formData.order_by,
    formData.ordering,
    formData.page_number,
    formData.proposal_name,
    formData.rating,
    formData.user_id,
  ]);

  return { loading: pending, proposalData: data, error };
};

export const useSingleProposalData = (formData: SingleProposalFormType) => {
  const init_proposal = {
    amount_requested: 0,
    challenge_id: 0,
    experience: "",
    fund_id: 0,
    no_assessments: 0,
    proposal_id: 0,
    rating: 0,
    solution: "",
    url: "",
    user_id: 0,
    proposal_description: "",
    proposal_name: "",
    fund_depletion: 0,
    meets_approval_threshold: false,
    is_challenge_proposal: false,
    reason_not_funded: "",
    funded_status: false,
    result_votes: 0,
    yes_votes: 0,
    no_votes: 0,
    fund_name: "",
    challenge_name: "",
    user_name: "",
    project_info: {
      amount_distributed: 0,
      amount_remaining: 0,
      completed_date: "",
      evidence: "",
      expected_completion_date: "",
      final_report: "",
      final_video: "",
      notes: "",
      project_completed: false,
      project_id: 0,
      project_on_track: false,
      project_status_description: "",
    },
    videos: [],
    media: [],
    assessments: [
      { assessment_question_id: 0, assessment_question_name: "", items: [] },
    ],
  };

  const [pending, setPending] = useState(true);
  const [data, setData] = useState<SingleProposalType>(init_proposal);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getSingleProposal(formData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Proposals Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }
        setData(init_proposal);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [formData]);

  return { loading: pending, proposalData: data, error };
};

export const useAllProposersData = (formData: proposerFormType) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<proposerCardSummaryType>({
    number_of_rows: 0,
    items: [],
  });
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);

    if (formData.challenge_id === 0 || formData.challenge_id === undefined) {
      setData({ number_of_rows: 0, items: [] });
    } else {
      (async () => {
        const { error, response, code } = await getAllProposers(formData);

        if (error === null) {
          setErrors(null);
          setData(response);
        } else {
          if (code === 404) {
            setErrors(`No Challenge Exists!`);
          } else {
            setErrors(`Some Error Occurred with Status code : ${code}`);
          }
          setData({ number_of_rows: 0, items: [] });
        }
        setPending(false);
      })();
    }
  }, [formData]);

  return { loading: pending, proposerData: data, error };
};

export const useSingleProposerData = (formData: SingleProposerFormType) => {
  const singleProposer_init = {
    user_id: 0,
    user_name: "",
    quick_stats_data: {
      number_of_proposals: 0,
      average_rating: 0,
      amount_requested: 0,
      funded_amount: 0,
      funded_proposals: 0,
      highest_proposal_rating: 0,
      highest_amount_requested: 0,
      total_result_votes: 0,
      total_up_votes: 0,
      total_down_votes: 0,
      conversion_percentage: 0,
      funding_percentage: 0,
    },
  };
  const [pending, setPending] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<SingleProposerInfoType>(singleProposer_init);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { response, error, code } = await getSingleProposer(formData);
      if (error === null) {
        setError(null);
        setData(response);
      } else {
        if (code === 404) {
          setError(`No Challenge Exists!`);
        } else {
          setError(`Some Error Occurred with Status code : ${code}`);
        }
        setData(singleProposer_init);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, []);

  return { loading: pending, proposerData: data, error: error };
};

export const useSingleFundData = (formData: SingleFundFormType) => {
  const single_fund_init = {
    fund_id: 0,
    fund_name: "",
    start_date: "",
    launched_date: "",
    quick_stats_data: {
      total_proposals: 0,
      fund_budget: 0,
      amount_requested: 0,
      funded_proposals: 0,
      funded_amount: 0,
    },
  };

  const [pending, setPending] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<FundCardType>(single_fund_init);

  useEffect(() => {
    setPending(true);
    if (!Number.isNaN(formData.fund_id)) {
      (async () => {
        const { response, error, code } = await getSingleFund(formData);
        if (error === null) {
          setError(null);
          setData(response);
          //console.log("success");
        } else {
          if (error === 404) {
            setError("No Fund Exists");
          } else {
            setError(`Some Error Occurred with Status code : ${code}`);
          }
          setData(single_fund_init);
        }
        setPending(false);
      })();
    } else {
      setData(single_fund_init);
      setPending(false);
    }

    //eslint-disable-next-line
  }, []);

  return { loading: pending, fundData: data, error: error };
};

export const useSingleChallengeData = (formData: singleChallengeFormType) => {
  const single_challenge_init: ChallengeCardType = {
    ranking: 0,
    fund_id: 0,
    challenge_id: 0,
    fund_name: "",
    challenge_name: "",
    description: "",
    challenge_url: "",
    challenge_amount: 0,
    number_of_proposals: 0,
    includes_proposals_sponsored_by_leftovers: false,
    quick_stats_data: {
      total_proposals: 0,
      amount_requested: 0,
      funded_proposals: 0,
      funded_amount: 0,
    },
  };
  const [error, setError] = useState<null | string>(null);
  const [pending, setPending] = useState<boolean>(true);
  const [data, setData] = useState<ChallengeCardType>(single_challenge_init);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, code, response } = await getSingleChallenge(formData);
      if (error === null) {
        setError(null);
        setData(response);
        //console.log("success");
      } else {
        if (code === 404) {
          setError("No Challenge Exists");
        } else {
          setError(code);
          setData(single_challenge_init);
        }
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, []);
  return { loading: pending, challengeData: data, error: error };
};

export const useFundsBudgetAnalyticsData = () => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<FundsBudgetAnalytics[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getFundsBudgetAnalytics();

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, []);

  return { loading: pending, fundsBudgetAnalyticsData: data, error };
};

export const useChallengeBudgetPerFunds = (fundId: number) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<ChallengeAnalyticsData[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getChallengeBugetPerFunds(fundId);
      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, [fundId]);

  return { loading: pending, challengeAnalyticsData: data, error };
};

export const useCompletedCounts = (
  completedCountFormData: completedCountFormDataType
) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    if (
      completedCountFormData.challenge_id === 0 ||
      completedCountFormData.challenge_id === "" ||
      completedCountFormData.challenge_id === undefined
    ) {
      setData([]);
    } else {
      setPending(true);

      (async () => {
        const { error, response, code } = await getCompletedCounts(
          completedCountFormData
        );
        if (error === null) {
          setErrors(null);
          setData(response);
        } else {
          if (code === 404) {
            setErrors(`No Funds Exists!`);
          } else {
            setErrors(`Some Error Occurred with Status code : ${code}`);
          }

          setData([]);
        }
        setPending(false);
      })();
    }
  }, [completedCountFormData]);
  return { loading: pending, completedCountsData: data, error };
};

export const useProposalRankings = (
  filterProposalFrom: filterProposalFormType
) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getProposalRankings(
        filterProposalFrom
      );

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, [filterProposalFrom]);

  return { loading: pending, proposalRankingData: data, error };
};

export const useProposerRankings = (
  filterProposalFrom: filterProposalFormType
) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getProposerRankings();

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, [filterProposalFrom]);

  return { loading: pending, proposerRankingData: data, error };
};

export const useAllFundNames = () => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getAllFundNames();

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, []);

  return { loading: pending, allFundNames: data, error };
};

export const useAllChallengeNames = () => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<ChallengeAnalyticsData[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getAllChallengeNames();

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, []);

  return { loading: pending, allChallengeNames: data, error };
};

export const useChallengeNames = (funds: number[]) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<challengeNamesDataType[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getChallengeNames(funds);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, [funds]);

  return { loading: pending, challengeNames: data, error };
};

export const useFundAvalaibilityData = (challenge_id: number | "") => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<FundAvailibilityType[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);

    if (
      challenge_id === 0 ||
      challenge_id === "" ||
      challenge_id === undefined
    ) {
      setData([]);
    } else {
      (async () => {
        const { error, response, code } = await getFundAvailibilityPerChallenge(
          challenge_id as number
        );

        if (error === null) {
          setErrors(null);
          setData(response);
        } else {
          if (code === 404) {
            setErrors(`No Funds Exists!`);
          } else {
            setErrors(`Some Error Occurred with Status code : ${code}`);
          }

          setData([]);
        }
        setPending(false);
      })();
    }
  }, [challenge_id]);

  return { loading: pending, fundAvailabilityData: data, error };
};

export const usePropertyData = (body: PropertyAPIType) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    if (body.fund_id === undefined) delete body.fund_id;
    if (body.proposal_status === undefined) delete body.proposal_status;
    (async () => {
      const { error, response, code } = await getProperty(body);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    // eslint-disable-next-line
  }, [
    body.aggregation_type,
    body.fund_id,
    body.property_name,
    body.proposal_status,
    body.status_grouping,
  ]);

  return { loading: pending, data, error };
};

export const useProjectStatus = (projectStatusForm: ProjectStatusFromType) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getProjectStatus(
        projectStatusForm
      );

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    // eslint-disable-next-line
  }, [
    projectStatusForm.fund_id,
    projectStatusForm.status_column,
    projectStatusForm.rating,
    projectStatusForm.amount_distributed,
    projectStatusForm.amount_requested,
  ]);

  return { loading: pending, projectStatusData: data, error };
};

export const useProperties = (propertiesForm: PropertiesFormType) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any>();
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);

    if (
      propertiesForm.challenge_id === 0 ||
      propertiesForm.challenge_id === "" ||
      propertiesForm.challenge_id === undefined
    ) {
      setData([]);
    } else {
      (async () => {
        const { error, response, code } = await getProperties(propertiesForm);

        if (error === null) {
          setErrors(null);
          setData(response);
        } else {
          if (code === 404) {
            setErrors(`No Funds Exists!`);
          } else {
            setErrors(error);
          }

          setData([]);
        }
        setPending(false);
      })();
    }
    // eslint-disable-next-line
  }, [propertiesForm]);

  return { loading: pending, propertiesData: data, error };
};

export const useCompletionTimeROI = () => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getCompletionTimeROI();

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Funds Exists!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
  }, []);

  return { loading: pending, completionTimeROIData: data, error };
};

export const useTwitterSentimentsData = (reqData: GetSentimentsAPIReqTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<SentimentsResultsTypes[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getTwitterSentiments(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [reqData.tweet_table_name]);

  return { loading: pending, sentimentsData: data, error };
};

export const useTwitterWordCloudData = (reqData: GetTwitterWordCloudTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<{ word: string; count: number }[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getTwitterWordCloud(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [reqData.tag_table_name, reqData.tweet_table_name]);

  return { loading: pending, wordCloudData: data, error };
};

export const useTwitterDistributionData = (
  reqData: GetTwitterDistributionTypes
) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<{ key: string; items: any[] }[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getTwitterDistribution(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [reqData.property_name, reqData.tweet_table_name]);

  return { loading: pending, distributionData: data, error };
};

export const useTwitterPropertyData = (reqData: GetTwitterPropertyTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<
    {
      items: any | any[];
      value: any;
      keyword: string;
    }[]
  >([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getTwitterProperty(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [
    reqData.create_keyword_items,
    reqData.create_year_items,
    reqData.group_by_month,
    reqData.group_by_year,
    reqData.property_name,
    reqData.tweet_table_name,
  ]);

  return { loading: pending, twitterPropertyData: data, error };
};

export const useProposerCorrelationMatrix = (
  formData: ProposerCorrelationFormType
) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any>({});
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getProposerCorrelationMatrix(
        formData
      );

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [
    formData.merge_new_previous_proposers,
    formData.include_correlation_colors,
  ]);

  return { loading: pending, proposerCorrelationData: data, error };
};

export const useTweets = (option: TweetsTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getTweets(option);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(error);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [
    option.date_range,
    option.property_name,
    option.search_value,
    option.tweet_table_name,
  ]);

  return { loading: pending, tweetsData: data, error };
};

export const useTweetOptions = (option: any) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getTweetsOptions(option);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [option.option]);

  return { loading: pending, tweetsOptionData: data, error };
};

export const useForumWordCloud = (reqData: GetForumWordCloudTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<{ word: string; count: number }[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getForumWordCloud(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [reqData.forum_column_name]);

  return { loading: pending, wordCloudData: data, error };
};

export const usePowerIndexResponse = (formData: PowerIndexAPIInputTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<{ coalitions: any[]; power_index: any[] }>({
    coalitions: [],
    power_index: [],
  });
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getPowerIndex(formData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(error);
        }

        setData({ coalitions: [], power_index: [] });
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [formData.voter_weights, formData.quota]);
  return { loading: pending, powerIndexData: data, error };
};

export const useForumPostData = (option: GetForumPostTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getForumPosts(option);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(error);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [option.date_range, option.property_name]);

  return { loading: pending, forumsData: data, error };
};

export const useRedditSentimentsData = (
  reqData: GetRedditSentimentsAPIReqTypes
) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<SentimentsResultsTypes[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getRedditSentiments(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [
    reqData.listing,
    reqData.post_category,
    reqData.reddit_table,
    reqData.time_filter,
  ]);

  return { loading: pending, sentimentsData: data, error };
};

export const useRedditWordCloud = (reqData: GetRedditWordCloudTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<{ word: string; count: number }[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getRedditWordCloud(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [reqData.post_category, reqData.listing, reqData.time_filter]);

  return { loading: pending, wordCloudData: data, error };
};

export const useRedditDistributionData = (
  reqData: GetRedditDistributionTypes
) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<{ key: string; items: any[] }[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getRedditDistribution(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [
    reqData.time_filter,
    reqData.post_category,
    reqData.listing,
    reqData.reddit_table,
    reqData.property_name,
  ]);

  return { loading: pending, distributionData: data, error };
};

export const useRedditPropertyData = (reqData: GetRedditPropertyTypes) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<
    {
      items: any | any[];
      value: any;
      keyword: string;
    }[]
  >([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getRedditProperty(reqData);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(`Some Error Occurred with Status code : ${code}`);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [
    reqData.create_keyword_items,
    reqData.create_year_items,
    reqData.group_by_month,
    reqData.group_by_year,
    reqData.property_name,
    reqData.reddit_table,
    reqData.time_filter,
    reqData.listing,
    reqData.post_category,
  ]);

  return { loading: pending, redditPropertyData: data, error };
};

export const useReddits = (option: GetRedditAPIPropsType) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);
    (async () => {
      const { error, response, code } = await getReddits(option);

      if (error === null) {
        setErrors(null);
        setData(response);
      } else {
        if (code === 404) {
          setErrors(`No Data Found!`);
        } else {
          setErrors(error);
        }

        setData([]);
      }
      setPending(false);
    })();
    //eslint-disable-next-line
  }, [
    option.date_range,
    option.property_name,
    option.search_value,
    option.date_range,
    option.listing,
    option.time_filter,
  ]);

  return { loading: pending, redditsData: data, error };
};

export const useRedditOptions = (option: any) => {
  const [pending, setPending] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [error, setErrors] = useState<string | null>(null);

  useEffect(() => {
    setPending(true);

    // for redditsOptions only call the API according to following
    //     When post_category is "Keyword Posts" fetch options with GetTweetsOptions API  using "Crypto Keywords" option
    // Else use {CardanoDevelopers,CardanoNFTs,CardanoStakePools,CardanoTrading,cardano,Cardano_ELI5}

    if (option.option !== "Keyword Posts") {
      setData([
        "CardanoDevelopers",
        "CardanoNFTs",
        "CardanoStakePools",
        "CardanoTrading",
        "cardano",
        "Cardano_ELI5",
      ]);
      setPending(false);
      setErrors(null);
    } else
      (async () => {
        const { error, response, code } = await getTweetsOptions({
          option: "Crypto Keywords",
        });

        if (error === null) {
          setErrors(null);
          setData(response);
        } else {
          if (code === 404) {
            setErrors(`No Data Found!`);
          } else {
            setErrors(`Some Error Occurred with Status code : ${code}`);
          }

          setData([]);
        }
        setPending(false);
      })();
    //eslint-disable-next-line
  }, [option.option]);

  return { loading: pending, tweetsOptionData: data, error };
};
